// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2VVhB","col":"styles_col__3RGcK","fulfillmentStatus":"styles_fulfillmentStatus__tsDyO","emailCol":"styles_emailCol__9aQTj"};